import React, { Component } from 'react';
import TaggedImage from './../taggedImage';
import './lookSideBySideImages.css';
import { withController, Parallax } from 'react-scroll-parallax';
import ScrollFadeIn from './../scrollFadeIn';
let imagesLoaded=0;
class LookBookSideBySideImages extends Component {

  onImageLoad = () =>{
    imagesLoaded++
    if(imagesLoaded.length == this.props.images.length){
      this.props.parallaxController.update();
    }
  }

  render() {
    let columns = 12/this.props.images.length;
    return(
      <div
        className="row max-width-container" style={{overflow:"hidden", lineHeight:0}}
      >
        {this.props.images && this.props.images.map((data, index) =>{
          return(
            <div
              key={data.backgroundImage}
              className={"small-12 medium-"+columns}
            >
              <ScrollFadeIn>
                <div className="look-book-side-by-side-image">
                  {data.latlng ?
                    <TaggedImage
                      image={data.image}
                      backgroundImage={data.backgroundImage}
                      latlng={data.latlng}
                      city={data.city}
                    />
                  :
                    <img
                      onLoad={this.onImageLoad}
                      src={data.image}
                      backgroundImage={data.backgroundImage}
                    />
                  }
                </div>
              </ScrollFadeIn>
            </div>
          )
        })}
      </div>
    )
  }
}

export default withController(LookBookSideBySideImages);



// WEBPACK FOOTER //
// ./src/components/lookBookSideBySideImages/index.js